var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    !_vm.loading && _vm.presentGroup
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("table", { staticClass: "table table-sm table-striped" }, [
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.records, function (r) {
                      return _c("tr", [
                        _c("td", [_vm._v(_vm._s(r.id))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.printDate(r.active_date, "DD.MM.YYYY"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { align: "right" } }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-outline-info",
                              on: {
                                click: function ($event) {
                                  return _vm.showGroup(r.id)
                                },
                              },
                            },
                            [_vm._v("посмотреть")]
                          ),
                        ]),
                      ])
                    }),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { attrs: { colspan: "10", align: "right" } }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-outline-info",
                            on: {
                              click: function ($event) {
                                return _vm.showGroup()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "создать на основе актуальной группы\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("EditGroup", {
                attrs: {
                  editGroup: _vm.editGroup,
                  allGroups: _vm.allGroups,
                  allUsers: _vm.allUsers,
                  schedule: _vm.shifts,
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Редактирование смен менеджеров")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }